function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cn from 'classnames';
import { renderFromComponentMap } from '@goodrx/x-core';
import { ImageBlock as ImageBlockDSM } from './components';
export const ImageBlock = props => {
  const {
    className,
    type
  } = props;
  const componentMap = {
    default: () => /*#__PURE__*/React.createElement(ImageBlockDSM, _extends({}, props, {
      className: cn(className, 'imageBlockType')
    }))
  };
  return renderFromComponentMap(componentMap, type || 'default');
};